



















import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import CollectionActionSchedule
  from '@/views/app/management/collections/components/actions/CollectionActionSchedule.vue'
import { EUserStatus, ICollectionTask, IResidentContact, IUser } from '@zunta/configurations'

import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { UserModule } from '@/store/modules/user.module'

@Component({
  components: { CollectionActionSchedule, Modal },
  props: {
    resident: {
      required: true
    }
  }
})
export default class ScheduleCallModal extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  newTask: Partial<ICollectionTask> = {}
  isLoading: boolean = false
  isSending: boolean = false

  get usersList () {
    return this.$store.state.user.users
  }

  get residentContacts () {
    return this.$store.state.resident.residentContacts.map((item: any) => item).sort((a: IResidentContact) => a.isPrimary ? -1 : 0)
  }

  get userListItems () {
    return this.usersList.map((user: IUser) => ({
      key: user.id,
      value: user.id,
      content: `${user.firstName} ${user.lastName}`
    }))
  }

  get selectedResident () {
    if (!this.$store.state.resident.selectedResident) {
      return null
    }
    return this.$store.state.resident.selectedResident
  }

  get contactsListItems () {
    return this.residentContacts.map((residentContact: IResidentContact) => {
      return {
        content: `${residentContact.firstName} ${residentContact.lastName}`,
        value: residentContact.id,
        key: residentContact.id
      }
    })
  }

  async mounted () {
    this.isLoading = true
    await Promise.all([
      this.userModuleInstance.getManagementUsersList({ status: EUserStatus.ACTIVE }),
      this.residentModuleInstance.fetchResidentById(this.$props.resident),
      this.residentModuleInstance.fetchResidentContacts(this.$props.resident)
    ])
    this.isLoading = false
  }

  async sendActionRequest ({ functionName, successMessage, payloadData }: any) {
    if (this.isSending) {
      return
    }
    this.isSending = true
    // @ts-ignore
    if (!this.residentModuleInstance[functionName]) {
      console.error(`${functionName} is not a function`)
      return
    }
    const payload = {
      residentId: this.$props.resident,
      data: {
        facility: typeof this.selectedResident.facility === 'number' ? this.selectedResident.facility : this.selectedResident.facility.id,
        ...payloadData
      }
    }
    // @ts-ignore
    const response = await this.residentModuleInstance[functionName](payload)
    this.isSending = false
    if (response === 'OK') {
      this.notifySuccess(successMessage)
      this.$emit('close')
    } else {
      this.notifyError()
    }
  }

  notifySuccess (message: string) {
    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: message,
      header: 'Collection Task',
      icon: 'warning'
    })
  }

  notifyError () {
    this.$eventBus.$emit('notify', {
      color: 'var(--status-error-color)',
      message: 'Something went wrong',
      header: 'Collection Task',
      icon: 'warning'
    })
  }
}
